import clsx from "clsx";
import React from "react";

const Button = ({ className, disabled, children, ...rest }) => {
  return (
    <button
      className={clsx(
        className,
        "h-12 sm:h-14 md:h-16 rounded-xl px-6 sm:px-8 md:px-10 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-base sm:text-lg md:text-xl transition-all hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0 shadow-md",
        disabled && "opacity-50 pointer-events-none"
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
